/* eslint-disable */
export const MS_COMPANY_CODE = 'VN'
export const MS_AUTHORITY_PREFIX = 'V'
export const MR_AUTHORITY_PREFIX = ''

export const AUTHORITY_HEADQUARTERS = 'HO'
export const AUTHORITY_HEAD_OF_SALES_DEPARTMENT = 'BM'
export const AUTHORITY_HEAD_OF_BRANCH = 'DM'
export const AUTHORITY_HEAD_OF_DEPARTMENT = 'TL'
export const AUTHORITY_SM = 'MR'

export const MS_AUTHORITY_HEADQUARTERS = `${MS_AUTHORITY_PREFIX}HO`
export const MS_AUTHORITY_HEAD_OF_SALES_DEPARTMENT = `${MS_AUTHORITY_PREFIX}BM`
export const MS_AUTHORITY_HEAD_OF_BRANCH = `${MS_AUTHORITY_PREFIX}DM`
export const MS_AUTHORITY_HEAD_OF_DEPARTMENT = `${MS_AUTHORITY_PREFIX}SM`
export const MS_AUTHORITY_SM = `${MS_AUTHORITY_PREFIX}SL`

export const MR_AUTHORITY_HEADQUARTERS = `HO`
export const MR_AUTHORITY_HEAD_OF_SALES_DEPARTMENT = `BM`
export const MR_AUTHORITY_HEAD_OF_BRANCH = `DM`
export const MR_AUTHORITY_HEAD_OF_DEPARTMENT = `TL`
export const MR_AUTHORITY_SM = `MR`

export const CAN_APPLY_FINEPLAY_AUTHORITIES = [
  MS_AUTHORITY_HEAD_OF_BRANCH,
  MS_AUTHORITY_HEAD_OF_DEPARTMENT
]

export const CAN_APPROVE_FINEPLAY = [
  MS_AUTHORITY_HEAD_OF_SALES_DEPARTMENT,
  MS_AUTHORITY_HEAD_OF_BRANCH
]

export const CAN_SHOW_SURVEY = [
	MR_AUTHORITY_HEAD_OF_BRANCH, 
	MR_AUTHORITY_HEAD_OF_DEPARTMENT,
	MR_AUTHORITY_SM
]

export const CAN_SHOW_TOGGLE_INSTITUTIONS = [
  MS_AUTHORITY_HEAD_OF_DEPARTMENT,
  MS_AUTHORITY_HEAD_OF_BRANCH,
  MR_AUTHORITY_HEAD_OF_DEPARTMENT,
  MR_AUTHORITY_HEAD_OF_BRANCH,
]



// WEBPACK FOOTER //
// ./src/config/index.js